import React, { useState, useEffect } from 'react';
import './Calificaciones.css';
import { useNavigate } from 'react-router-dom';
import FooterCorp from '../modulos/footerCorp';
import obtieneDatos from '../tools/obtieneDatosCookiesUsuario';
import GestorUsuariosCalificaciones from './GestorUsuariosCalificaciones';
import GestorInstancias from './GestorInstancias';
import GestorAlumnos from './GestorAlumnos';
import BuscadorAlumno from './BuscadorAlumno.jsx';
import socket from '../tools/socke';
import comprueboPermisos from '../tools/comprueboPermisos.js';
import BlanqueadorContraseaUsuariosQR from '../Inscripciones/BlanqueadorContraseaUsuariosQR.js';
import Pantalla from './Pantalla.jsx';

const Menu = () => {

  const Usuario = obtieneDatos();
  const navigate = useNavigate();

  const [selectedComponent, setSelectedComponent] = useState('Component2');

  // SOCKET
  useEffect(() => {
    socket.emit('joinRoom', socket.id);

    socket.on('listaPresentes', (listaObtenida) => {
//       console.log(listaObtenida);
    });

    return () => {
      socket.off('listaPresentes');
    };
  }, []);

  // SEGURIDAD
  useEffect(() => {
    if (!Usuario?.id) {
      alert("Acceso no Autorizado");
      window.location.href = './';
    }
  }, []);

  const handleMenuClick = (component) => {
    setSelectedComponent(component);
  };

  const renderComponent = () => {
    switch (selectedComponent) {
      case 'Component1':
        return <GestorInstancias />;
      case 'Component2':
        return <GestorAlumnos />;
      case 'Component3':
        return <GestorUsuariosCalificaciones />;
      case 'Component4':
        return <BuscadorAlumno />;
        case 'Component5':
        return <Pantalla />;
      default:
        return <GestorInstancias />;
    }
  };

  return (
    <div className="ds-layout">

      {/* SIDEBAR */}
      <aside className="ds-sidebar">
        <div className="ds-logo">Gestion Mi ISeP</div>

        <div className="ds-menu">
           <div onClick={() => handleMenuClick('Component2')}>👨‍🎓 Alumnos</div>
          <div onClick={() => handleMenuClick('Component1')}>📊 Instancias</div>
         

          {(comprueboPermisos(Usuario.funcion,"Gestiono Usuarios Mi ISeP") || Usuario.destino=="7") &&
            <div onClick={() => handleMenuClick('Component3')}>👥 Usuarios</div>
          }

          {(comprueboPermisos(Usuario.funcion,"Veo Alumnos Mi ISeP") || Usuario.destino=="7") &&
           <><div onClick={() => handleMenuClick('Component4')}>🔎 Buscar</div> 
            <div onClick={() => handleMenuClick('Component5')}> Blanqueo de Pass QR</div></> 
          } 
         

          <div className="logout" onClick={() => navigate('/usuarioLogueado')}>
            ↩ Volver
          </div>
        </div>
      </aside>

      {/* MAIN */}
      <div className="ds-main">


        {/* MÓDULO DINÁMICO */}
        <section className="ds-module">
          {renderComponent()}
        </section>

        <FooterCorp />

      </div>
    </div>
  );
};

export default Menu;